const Email = (): JSX.Element => (
  <>
    <path
      d="M3.56,0C1.59,0,0,1.49,0,3.33v1.94l15.01,7.03c.63,.29,1.36,.29,1.99,0l15.01-7.03v-1.94c0-1.84-1.59-3.33-3.56-3.33H3.56Z"
      fill="currentColor"
    />
    <path
      d="M32,8.06l-13.81,6.48c-1.38,.65-3,.65-4.37,0L0,8.06v8.6c0,1.84,1.59,3.33,3.56,3.33H28.44c1.96,0,3.56-1.49,3.56-3.33V8.06Z"
      fill="currentColor"
    />
  </>
);

export default Email;
